import { Link } from "react-router-dom";
import { clinicInfo } from "../../../mocks/home-data";
import FadeIn from "../../../components/base/FadeIn";

const infoCards = [
  {
    icon: "ri-map-pin-2-line",
    label: "Adres",
    value: "Kavacık Subayevleri Mah., Şehit Makbule Sok. No:2-A-K, Keçiören / Ankara",
    link: "https://maps.google.com/?q=Keçiören+Ankara",
    linkText: "Yol tarifi al",
  },
  {
    icon: "ri-time-line",
    label: "Çalışma Saatleri",
    value: "Her Gün: 09:00 – 21:00",
    sub: "",
  },
  {
    icon: "ri-phone-line",
    label: "Telefon",
    value: "0539 696 06 77",
    link: "tel:05396960677",
    linkText: "Hemen ara",
  },
  {
    icon: "ri-whatsapp-line",
    label: "WhatsApp",
    value: "Hızlı mesaj gönder",
    link: "https://wa.me/905396960677",
    linkText: "Mesaj at",
    accent: "green",
  },
];

export default function ContactCTA() {
  return (
    <section className="relative py-24 md:py-32 overflow-hidden">
      {/* Background — cute animals, not doctor */}
      <div className="absolute inset-0">
        <img
          src="/assets/images/cta-bg-animals.jpg"
          alt="Sevimli Dostlar"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-white/80 via-white/65 to-white/50" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">

            {/* Left — Main CTA */}
            <FadeIn>
              <div>
                <span className="inline-block px-4 py-1.5 bg-primary-100 text-primary-700 rounded-full text-sm font-medium mb-6">
                  Hemen İletişime Geçin
                </span>
                <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-5 leading-tight">
                  Randevunuz İçin{" "}
                  <span className="font-serif italic text-primary-700">Bizi Arayın</span>
                </h2>
                <p className="text-gray-600 text-lg mb-8 leading-relaxed max-w-lg">
                  Tüylü ve pullu dostlarınızın sağlığı için hemen iletişime geçin. 
                  Acil durumlar için telefon desteğimiz aktif.
                </p>

                {/* Big Phone */}
                <a
                  href={`tel:${clinicInfo.phoneRaw}`}
                  className="inline-flex items-center gap-3 text-3xl md:text-4xl font-bold text-gray-900 hover:text-primary-700 transition-colors mb-8"
                >
                  <div className="w-12 h-12 rounded-2xl bg-primary-100 flex items-center justify-center">
                    <i className="ri-phone-fill text-xl text-primary-700 w-6 h-6 flex items-center justify-center" />
                  </div>
                  {clinicInfo.phone}
                </a>

                <div className="flex flex-col sm:flex-row gap-4">
                  <a
                    href={`tel:${clinicInfo.phoneRaw}`}
                    className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-primary-600 hover:bg-primary-700 text-white font-semibold rounded-xl transition-all duration-300 whitespace-nowrap shadow-lg hover:shadow-xl hover:-translate-y-0.5"
                  >
                    <i className="ri-phone-line w-5 h-5 flex items-center justify-center" />
                    Hemen Ara
                  </a>
                  <Link
                    to="/iletisim"
                    className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-white text-gray-800 font-semibold rounded-xl border-2 border-gray-200 hover:border-primary-300 hover:text-primary-700 transition-all duration-300 whitespace-nowrap shadow-sm"
                  >
                    <i className="ri-calendar-line w-5 h-5 flex items-center justify-center" />
                    Online Randevu
                  </Link>
                </div>

                {/* Instagram */}
                <div className="mt-8 flex flex-wrap items-center gap-3">
                  <span className="text-sm text-gray-400">Instagram:</span>
                  <a
                    href={`https://instagram.com/${clinicInfo.instagram1}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-2 px-4 py-2 bg-white rounded-full text-sm text-gray-600 hover:text-pink-600 font-medium transition-all border border-gray-200 hover:border-pink-200 shadow-sm"
                  >
                    <i className="ri-instagram-line w-4 h-4 flex items-center justify-center" />
                    @ihsan_ozer_veteriner_klinigi
                  </a>
                  <a
                    href={`https://instagram.com/${clinicInfo.instagram2}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-2 px-4 py-2 bg-white rounded-full text-sm text-gray-600 hover:text-pink-600 font-medium transition-all border border-gray-200 hover:border-pink-200 shadow-sm"
                  >
                    <i className="ri-instagram-line w-4 h-4 flex items-center justify-center" />
                    @ankarakusveterineri
                  </a>
                </div>
              </div>
            </FadeIn>

            {/* Right — Info Cards */}
            <FadeIn delay={0.2} direction="left">
              <div className="grid sm:grid-cols-2 gap-4">
                {infoCards.map((card, index) => (
                  <div
                    key={card.label}
                    className="bg-white/90 backdrop-blur-sm rounded-2xl p-6 border border-gray-100 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-300"
                  >
                    <div className={`w-10 h-10 rounded-xl flex items-center justify-center mb-4 ${
                      card.accent === "green" ? "bg-green-100" : "bg-primary-100"
                    }`}>
                      <i className={`${card.icon} text-lg w-5 h-5 flex items-center justify-center ${
                        card.accent === "green" ? "text-green-600" : "text-primary-600"
                      }`} />
                    </div>
                    <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-1">{card.label}</p>
                    <p className="text-gray-800 font-medium text-sm leading-relaxed">{card.value}</p>
                    {card.sub && <p className="text-gray-400 text-xs mt-1">{card.sub}</p>}
                    {card.link && (
                      <a
                        href={card.link}
                        target={card.link.startsWith("http") ? "_blank" : undefined}
                        rel={card.link.startsWith("http") ? "noopener noreferrer" : undefined}
                        className={`inline-flex items-center gap-1 text-xs font-semibold mt-3 transition-colors ${
                          card.accent === "green"
                            ? "text-green-600 hover:text-green-700"
                            : "text-primary-600 hover:text-primary-700"
                        }`}
                      >
                        {card.linkText}
                        <i className="ri-arrow-right-line w-3 h-3 flex items-center justify-center" />
                      </a>
                    )}
                  </div>
                ))}
              </div>
            </FadeIn>

          </div>
        </div>
      </div>
    </section>
  );
}
